import { render, staticRenderFns } from "./RestPwdSms.vue?vue&type=template&id=2990787f&scoped=true&"
import script from "./RestPwdSms.vue?vue&type=script&lang=js&"
export * from "./RestPwdSms.vue?vue&type=script&lang=js&"
import style0 from "./RestPwdSms.vue?vue&type=style&index=0&id=2990787f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990787f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-company(微信公众号-企业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2990787f', component.options)
    } else {
      api.reload('2990787f', component.options)
    }
    module.hot.accept("./RestPwdSms.vue?vue&type=template&id=2990787f&scoped=true&", function () {
      api.rerender('2990787f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/me/settings/RestPwdSms.vue"
export default component.exports